module.exports = __webpack_public_path__ + "28eaa033217bb1d835561681d95b1147.png";